import { useState } from 'react';
import { PageShell, Section } from '~/components/layout';
import { AudienceToggle, CtaBanner, PricingTable } from '~/components/sections';
import type { Audience } from '~/content/pricing';
import { useContent } from '~/lib/useLanguage';

export function PricingPage() {
  const { shared, ui } = useContent();
  const [audience, setAudience] = useState<Audience>('personal');

  return (
    <PageShell>
      <Section className="pt-16 md:pt-24 !pb-10">
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-12 text-center">
          <h1 className="text-[40px] leading-[1.1] font-semibold tracking-[-0.03em] text-balance md:text-title-m">
            {ui.pricing.heading}
          </h1>
          <AudienceToggle value={audience} onChange={setAudience} />
        </div>
      </Section>
      <PricingTable audience={audience} />
      <CtaBanner content={shared.defaultCtaBanner} />
    </PageShell>
  );
}
